import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/views/main'
import MainTop from '@/views/main-top'
import MainBottom from '@/views/main-bottom'
import Home from '@/views/modules/home'
import Info from '@/views/modules/info'
import New from '@/views/modules/new'
import Industrial from '@/views/modules/industrial'
import Party from '@/views/modules/party'
import Recruit from '@/views/modules/recruit'
import New4 from '@/views/modules/new-4'
import NewDetails from '@/views/modules/new-details'
import Culture from '@/views/modules/culture'


Vue.use(Router)
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main,
      children:[
        {
          path: '',
          name: 'home',
          component: Home
        }
        ,
        {
          path: '/info',
          name: 'info',
          component: Info
        }
        ,
        {
          path: '/new',
          name: 'new',
          component: New
        },
        {
          path: '/industrial',
          name: 'industrial',
          component: Industrial
        },
        {
          path: '/party',
          name: 'party',
          component: Party
        },
        {
          path: '/recruit',
          name: 'recruit',
          component: Recruit
        },
        {
          path: '/new-4',
          name: 'new-4',
          component: New4
        }
        ,
        {
          path: '/new-details',
          name: 'new-details',
          component: NewDetails
        }
        ,
        {
          path: '/culture',
          name: 'culture',
          component: Culture
        }
      ]
    },
    {
      path: '/views/main-top',
      name: 'main-top',
      component: MainTop
    }
    ,
    {
      path: '/views/main-bottom',
      name: 'main-bottom',
      component: MainBottom
    }

  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js